import { render, staticRenderFns } from "./XPathDialog.vue?vue&type=template&id=4edc4900"
import script from "./XPathDialog.vue?vue&type=script&lang=ts"
export * from "./XPathDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports